'use strict';
angular.module('app')

.directive('uefaForgotPasswordForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindings: {},
        controller: 'ForgotPasswordFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'directives/forgot/uefaForgotPasswordForm.html'
    };
});
